import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";


export const OtorgamientoCreditoMhusa = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
}) => {
  const [comentarios, setComentarios] = useState("");
  const [estatus, setEstatus] = useState({});
  const [documentacion, setDocumentacion] = useState([]);
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };



  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACDocumentacion/GetOtorgamientoMhusa?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
        setDocumentacion(result.documentacion);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);
  const onEnviarComentario = (valor) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "VALIDAR CONDICIONES DE LA OPERACION",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      comentarios,
      estatus: valor,
    };
    request
      .post("ACTimeLineComentarios/OtorgamientoCredito", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
        setComentarios("");
       
        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const otorgamientodocumento = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ACDocumentacion/OtorgamientoAgregarDocumento?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDocumentacion(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  return (
    <div className="analisis-credito-modal-mhusa">
      <div className="analisis-credito-modal-mhusa-content">
        <div className="analisis-credito-modal-mhusa-content-buttons">
          {estatus.habilitar === undefined ||
            estatus.habilitar === null ||
            estatus.habilitar === false ? (
            <div
              className={`analisis-credito-modal-mhusa-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
            >
              <div className="analisis-credito-modal-mhusa-content-comentarios-svg">
                <OnGetIcon icon={estatus.icono} />
              </div>
              <div className="analisis-credito-modal-mhusa-content-comentarios-div">
                {estatus.comentarios}
              </div>
            </div>
          ) : (
            <div className="analisis-credito-modal-mhusa-content-buttons-container">
              <TextField
                fullWidth
                size="small"
                label="COMENTARIOS"
                className=""
                multiline
                rows={3}
                type="text"
                onChange={({ target }) => {
                  ValSpecialCharacters(
                    "condiciones",
                    target.value,
                    onChange,
                    true,
                    500
                  );
                }}
                value={comentarios}
              />
              <div className="analisis-credito-modal-mhusa-content-buttons-container-table scroll-4">
                <table cellSpacing={0} cellPadding={0}>
                  <thead>
                    <tr>
                      <th>Documento</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentacion.map((item) => (
                      <tr>
                        <td>{item.documento}</td>
                        <td>
                          {item.tiene_documentacion ? (
                            <div
                              className="otorgamiento-cancelar"
                              onClick={() =>
                                otorgamientodocumento(item.iddocumento)
                              }
                            >
                              Cancelar
                            </div>
                          ) : (
                            <div
                              className="otorgamiento-solicitar"
                              onClick={() =>
                                otorgamientodocumento(item.iddocumento)
                              }
                            >
                              Solicitar
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <dvi className="analisis-credito-modal-mhusa-content-buttons-container-buttons">
                <div
                  className="analisis-credito-modal-mhusa-content-acept-button"
                  onClick={() => {
                    onEnviarComentario("A");
                  }}
                >
                  <CheckCircleIcon />
                  <div>Aprobar crédito</div>
                </div>
                {/* <div
                  className="analisis-credito-modal-mhusa-content-warning-button"
                  onClick={() => {
                    onEnviarComentario("M");
                  }}
                >
                  <WarningIcon />
                  <div>SOLICITAR CAMBIO EN LAS CONDICIONES</div>
                </div> */}
              </dvi>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};